export const blockIconsAndroidWidgetsNew = (
	<span className='material-symbols-outlined'>widgets</span>
);
